export enum CertificateType {
  QWAC = 'qwac',
  QSEALC = 'qsealc',
}

export interface AddCertificatePayload {
  fileName: string;
  certificate: string;
  certificateType: CertificateType;
}

export interface AddCertificateResponse {
  error: boolean;
  type: string;
}

export type CertificatesDetailsResponse = {
  payload: CertificateDetails[];
  error: boolean;
  type: string;
};

export interface CertificateDetails {
  clientId: string;
  fingerprint: string;
  certificateType: CertificateType;
  filename: string;
  uploadDate: string;
  validFrom: string;
  validTo: string;
  enabled: boolean;
}
